import HomeI18n from './Home/Home.i18n.en';
export default {
  home: {
    ...HomeI18n,
    contactTeacher: 'This assessment has been deleted. Please contact your teacher.',
    attemptClose: 'This assessment has been closed by your teacher.'
  }
};